module.exports = __webpack_public_path__ + "static/media/inn.430a7f5f.webp";